import { useSelector } from "react-redux";

interface Ad {
  id: number;
  title: string;
  sub_title: string;
  img: string;
  btn_tip: string;
  jump_url: string;
}

interface SidebarAdProps {
  className?: string;
  adList?: Ad[];
}

export default function SidebarAd({ className = '',adList= []  }: SidebarAdProps) {
  const sidebarAds = [
    {
      id: 1,
      title: '体育博彩',
      subtitle: '合法平台 安全可靠',
      image: 'https://readdy.ai/api/search-image?query=modern%20sports%20betting%20interface%20with%20soccer%20ball%20and%20basketball%20on%20clean%20white%20background%2C%20professional%20gambling%20app%20design%2C%20minimalist%20style%20with%20green%20and%20blue%20accents&width=300&height=200&seq=betting1&orientation=landscape',
      buttonText: '立即体验',
      bgColor: 'bg-gradient-to-br from-green-500 to-emerald-600'
    },
    {
      id: 2,
      title: '运动保险',
      subtitle: '专业运动员必备',
      image: 'https://readdy.ai/api/search-image?query=sports%20insurance%20concept%20with%20protective%20shield%20and%20various%20sports%20equipment%20including%20football%20basketball%20tennis%20racket%2C%20clean%20modern%20design%20with%20blue%20safety%20theme&width=300&height=200&seq=insurance1&orientation=landscape',
      buttonText: '了解详情',
      bgColor: 'bg-gradient-to-br from-blue-500 to-cyan-600'
    },
    {
      id: 3,
      title: '健身课程',
      subtitle: '专业教练在线指导',
      image: 'https://readdy.ai/api/search-image?query=online%20fitness%20training%20with%20professional%20coach%20demonstration%2C%20modern%20gym%20equipment%20and%20workout%20scene%2C%20energetic%20atmosphere%20with%20orange%20and%20red%20tones&width=300&height=200&seq=fitness1&orientation=landscape',
      buttonText: '免费试听',
      bgColor: 'bg-gradient-to-br from-orange-500 to-red-600'
    }
  ];
  const settingConfigInfo = useSelector((state: any) => state.settings.configInfo);
  console.log('adList:', adList);
  const handleAdClick = (url: string) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };
  return (
    <div className={`space-y-6 ${className}`}>
      {/* {sidebarAds.map((ad) => (
        <div key={ad.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
          <div className="relative">
            <img
              src={ad.image}
              alt={ad.title}
              className="w-full h-32 object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/20"></div>
          </div>
          
          <div className="p-4">
            <h4 className="font-bold text-gray-900 mb-2">{ad.title}</h4>
            <p className="text-sm text-gray-600 mb-3">{ad.subtitle}</p>
            <button className={`w-full ${ad.bgColor} text-white py-2 px-4 rounded-lg font-medium hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap text-sm`}>
              {ad.buttonText}
            </button>
          </div>
        </div>
      ))} */}
      {adList.map((ad) => (
        <div 
          key={ad.id} 
          className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 cursor-pointer"
          onClick={() => handleAdClick(ad.jump_url)}
        >
          <div className="relative">
            <img
              src={settingConfigInfo?.image_server + ad.img}
              alt={ad.title}
              className="w-full h-32 object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/20"></div>
          </div>
          
          <div className="p-4">
            <h4 className="font-bold text-gray-900 mb-2">{ad.title}</h4>
            <p className="text-sm text-gray-600 mb-3">{ad.sub_title}</p>
            <button className={`w-full bg-gradient-to-br from-blue-500 to-cyan-600 text-white py-2 px-4 rounded-lg font-medium hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap text-sm`}>
              {ad.btn_tip}
            </button>
          </div>
        </div>
      ))}
      {/* 固定广告位 */}
      <div className="bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500 rounded-lg p-4 text-white text-center">
        <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
          <i className="ri-vip-crown-line text-2xl"></i>
        </div>
        <h4 className="font-bold mb-2">升级VIP会员</h4>
        <p className="text-sm text-white/90 mb-3">无广告观看 + 高清画质</p>
        <button className="bg-white text-orange-600 px-4 py-2 rounded-lg font-semibold text-sm hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
          立即升级
        </button>
      </div>
    </div>
  );
}
